module.exports = __webpack_public_path__ + "static/meta/sqs/2017/layout_metadata.1740715.tsv";


//////////////////
// WEBPACK FOOTER
// ./src/components/sqs/2017/meta/layout_metadata.tsv
// module id = f/RT
// module chunks = 0